export const NO_EDIT_PERMISSION_MESSAGE =
  'You do not have permission to change exclusion rules. Contact your administrator to request access.'

export const NO_DELETE_PERMISSION_MESSAGE =
  'You do not have permission to delete exclusion rules. Contact your administrator to request access.'

export const RULE_CONFLICT_MESSAGE =
  'Someone else changed this rule while you were editing. Reload it to see their version.'

export const RULE_GONE_MESSAGE = 'This rule no longer exists. It may have been deleted.'

export const TOO_MANY_RECORDS_MESSAGE =
  'You can exclude up to 1,000 records in one rule. Select fewer records and try again.'

export const EXCLUSION_FIELDS_UNAVAILABLE_MESSAGE = 'Exclusion rules are unavailable right now. Please try again later.'

export const NO_RECORDS_TO_EXCLUDE_MESSAGE =
  'This CPI has no records yet. An exclusion rule can be created once there is data to exclude.'
